module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_iter-step.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_iter-step.js
// module chunks = 0